import { Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
    selector: 'c-validation-error',
    templateUrl: './validation-error.component.html',
    styleUrls: ['./validation-error.component.scss'],
    standalone: false
})
export class ValidationErrorComponent {
  @Input() validationMessages: ValidationErrors | undefined;
  @Input() controlValue: string | undefined;
}
